export const addCandidate = '/user';
export const getCandidates = '/user/searchCandidates/';
export const updateCandidate = '/user/';
export const updateCandidateStatus = '/user/updateStatus/';
export const getCandidateDetails = '/user/getUserById/';
